/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlanLength/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import Type from './Type/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlanLength({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/DefaultPayorSchedule/PaymentPlanLength",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsDataDefaultPayorScheduleTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.type',
})
let constantData = 'PAYMENT_PLAN_LENGTH'
let aggregateData = fromAggregate.equals(settingsDataDefaultPayorScheduleTypeValueData, constantData)
let onClick = fromHelpers.useOnClickInstallmentAmount({
  children,
  viewPath,
  onChange
  
})
let settingsDataDefaultPayorSchedulePaymentPlanLengthValueValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.payment_plan_length.value',
})
let settingsDataDefaultPayorSchedulePaymentPlanLengthValueChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.payment_plan_length.value',
})
let settingsDataDefaultPayorScheduleTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.type',
})
let constantData1 = 'PAYMENT_PLAN_LENGTH'
let aggregateData1 = fromAggregate.equals(settingsDataDefaultPayorScheduleTypeValueData1, constantData1)
  return (<React.Fragment
>
<div
  data-testid="PaymentPlanLength.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1vu4vi': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="settings.data.default_payor_schedule.type"
 data="'PAYMENT_PLAN_LENGTH'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
 width={220}
 text="Default payment plan length"
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="settings.data.default_payor_schedule.payment_plan_length.value"
 onChange={settingsDataDefaultPayorSchedulePaymentPlanLengthValueChangeData}
 value={settingsDataDefaultPayorSchedulePaymentPlanLengthValueValueData}
 data="settings.data.default_payor_schedule.type"
 data="'PAYMENT_PLAN_LENGTH'"
 aggregate="/Data/aggregate equals"
 disabled={!aggregateData1}
 type="number"
 marginTop={0}
 flexGrow={0}
 flexBasis="0%"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 maxWidth={150}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder={0}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
{children}
</React.Fragment>)
}